import { FieldProps } from '../../entity/entityTypes';
import React from 'react';
import { RugIcon } from '../icons/RugIcon';

export function RaceFieldBoxField(props: FieldProps) {
  const { value } = props;
  return <RugIcon rugNumber={(value as any) as number} />;
}
